import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import MultiActionDialogManager from '@/components/common/MultiActionDialogManager';
import PageLoader from '@/components/common/PageLoader';

type BasicPageLayoutProps = {
  children: React.ReactNode;
  className?: string;
  ['data-testid']?: string;
  hideFAB?: boolean;
  id?: string;
  loading?: boolean;
};

function BasicPageLayout({
  children,
  className,
  'data-testid': dataTestid = '',
  hideFAB,
  id,
  loading,
  ...props
}: BasicPageLayoutProps) {
  if (loading) {
    return <PageLoader isVisible />;
  }

  return (
    <div
      className={classNames(
        className,
        'flex min-h-full w-full flex-1 flex-col md:flex-row',
      )}
      {...(id !== null && { id })}
      {...(dataTestid !== '' && { 'data-testid': dataTestid })}
      {...props}
    >
      {children}
      {!hideFAB && <MultiActionDialogManager />}
    </div>
  );
}
export default BasicPageLayout;
